export const BAND1_MONTHLY = 179;
export const BAND2_MONTHLY = 129;
export const ANNUAL_DISCOUNT = 14;
export const BAND1_ANNUAL = BAND1_MONTHLY - ANNUAL_DISCOUNT;
export const BAND2_ANNUAL = BAND2_MONTHLY - ANNUAL_DISCOUNT;
export const MIN_USERS = 5;
export const ANNUAL_MIN_USERS = 10;
export const ENTERPRISE_MIN_USERS = 50;
export const ONBOARDING_BASE = 8775;
